import React from 'react';
import './progress-bar.scss';
import PropTypes from 'prop-types';

const MAX_VAL = 100;
const MIN_VAL = 0;

const ProgressBarColors = {
  PRIMARY: 'color-primary',
  SUCCESS: 'color-success',
  ERROR: 'color-error',
};

const ProgressBar = ({ value, showValue, color }) => {
  const numValue = !Number.isNaN(+value) ? Math.min(MAX_VAL, Math.max(MIN_VAL, +value)) : MIN_VAL;
  const barWidth = ((numValue - MIN_VAL) * 100) / (MAX_VAL - MIN_VAL);

  const getText = () => (showValue ? (
    <div className="progress-bar-value">
      {`${numValue}%`}
    </div>
  ) : null);

  return (
    <div className="progress-bar-cont">
      <div className={`progress-bar-rail ${color}`}>
        <div className="progress-bar-bar" style={{ marginLeft: `${barWidth - 100}%` }} />
      </div>
      {getText()}
    </div>
  );
};

ProgressBar.propTypes = {
  value: PropTypes.number,
  showValue: PropTypes.bool,
  color: PropTypes.string,

};

ProgressBar.defaultProps = {
  value: 50,
  showValue: true,
  color: ProgressBarColors.PRIMARY,
};

export {
  ProgressBar as default,
  ProgressBarColors,
};
